import {
  ICategorySoldProducts,
  ISoldProducts,
  TComplexSectionData,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { isProductChecked } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/soldProducts/checkBoxThree/helpers/isProductChecked'

import { deleteProduct } from './deleteProduct'
import { isExistCategoryKeyInData } from './isExistCategoryKeyInData'

export const checkProducts =
  (updateFormData: (data: TComplexSectionData) => void, data: ICategorySoldProducts[]) =>
  (product: ISoldProducts, productCategory: ICategorySoldProducts) => {
    if (!isExistCategoryKeyInData(data, productCategory.Key)) {
      updateFormData([
        ...(data || []),
        { Key: productCategory.Key, Name: productCategory.Name, Products: [product] },
      ])
    } else {
      if (
        isProductChecked({
          selectedData: data,
          productKey: product.Key,
          categoryKey: productCategory.Key,
        })
      ) {
        deleteProduct({ updateFormData, productCategory, data, product })
      } else {
        const newData = data.map((el) => {
          if (el.Key === productCategory.Key) {
            return { ...el, Products: [...el.Products, product] }
          }
          return el
        })
        updateFormData(newData)
      }
    }
  }
